export const QUOTED_RESULTS_PRODUCT_ITEM_TEST_ID = 'quoted-results-product-item';
